module.exports = __webpack_public_path__ + "img/HQ-OA-360V05NU-T.e6f05814.jpg";